<template>
    <header class="siteheader">
        <div class="siteheader__container">
            <LogoText></LogoText>
            <a class="siteheader__help" @click.prevent="openHeaderModal()">
                Hulp nodig?
                <!--<svg v-if="action=='help'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 19">-->
                <!--    <path fill-rule="evenodd" d="M13.6 6c0-1.5-.2-3.3-2.1-4.9-1-.8-1.6-.6-2.3-.1-.7.5-2 1.8-2.3 2.5-.3.8.8 2.1 1.4 2.7.6.6 1 0 1.2.3.6.6 0 3.2-.8 4.5-.7 1.3-2.7 3.2-3.4 3-.4-.1-.1-.7-1-1-.8-.2-2.5-.4-3 .2-.4.7-1 2.4-1 3.3-.1.8 0 1.4 1.3 1.9 2.3.9 3.9.1 5.2-.6A14.7 14.7 0 0013.6 6z"/>-->
                <!--</svg>-->
            </a>
        </div>
    </header>
</template>

<script>
import InfosModal from "../modals/InfosModal";
import LogoText from "../../nl/LogoText";
export default {
    name: "SiteHeader",
    components:{LogoText},
    props:{
        action:{
            type:String,
            default:'infos',
        }
    },
    methods:{
        openHeaderModal() {
            // if(this.action=='infos'){
            this.$buefy.modal.open({
                component: InfosModal,
                props: {
                    activeTab: 'faq'
                }
            })
            dataLayer.push({
                event:'openModal',
                step:this.$store.get('general_data/current_step'),
                eventSource: 'header',
                modalTab:'faq',
            })
            // } else {
            //     this.$buefy.modal.open({
            //         component: HelpModal,
            //     })
            // }
        }
    },
    computed: {
        formUrl() {
            return `${location.origin}/${window.slug}`
        },
        isMobile() {
            return window.innerWidth <= 768;
        }
    }
}
</script>

<style scoped>

</style>
